import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { ArrowLeft } from "lucide-react";
import { USDollar } from "~/functions";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const current = payload.find((item) => item.dataKey === "current");
  const compare = payload.find((item) => item.dataKey === "compare");
  const label = payload[0]?.payload?.name || "";

  return (
    <div className="rounded-xl border border-gray-200 bg-white text-gray-900 shadow-[0_6px_24px_rgba(0,0,0,0.08)] p-3">
      <p className="mb-1 font-semibold">{label}</p>
      <div className="text-sm space-y-1">
        {current && (
          <p className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#EE5827] rounded-sm"></span>
            <span className="font-medium">Current:</span>{" "}
            {USDollar.format(current.value || 0)}
          </p>
        )}
        {compare && (
          <p className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#9CA3AF] rounded-sm"></span>
            <span className="font-medium">Compare:</span>{" "}
            {USDollar.format(compare.value || 0)}
          </p>
        )}
      </div>
    </div>
  );
};

export default function ProfitLossCompareChart({ data, onClose }) {
  if (!data) return null;
  const chartData = [
    {
      name: "Income",
      current: data.income || 0,
      compare: data.compareMonth?.income || 0,
    },
    {
      name: "Expenses",
      current: data.expenses || 0,
      compare: data.compareMonth?.expenses || 0,
    },
    {
      name: "Total",
      current: data.total || 0,
      compare: data.compareMonth?.total || 0,
    },
  ];

  return (
    <div className="w-full p-4 border rounded-lg mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <button
            onClick={onClose}
            className="flex items-center gap-1 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={20} />
          </button>
          <h2 className="text-lg font-bold">Profit & Loss Comparison</h2>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-[#EE5827] rounded-sm"></div>
            <span className="text-sm">Current</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-[#9CA3AF] rounded-sm"></div>
            <span className="text-sm">Compare</span>
          </div>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} strokeOpacity={0.15} />
          <XAxis dataKey="name" fontSize={12} />
          <YAxis tickFormatter={(value) => USDollar.format(value)} fontSize={12} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
          <Legend
            verticalAlign="top"
            wrapperStyle={{ fontSize: 12, marginTop: -8 }}
            iconType="plainline"
          />
          <Bar dataKey="current" fill="#EE5827" radius={[4, 4, 0, 0]} />
          <Bar dataKey="compare" fill="#9CA3AF" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
